export default __webpack_public_path__ + "static/media/payment-info-1x.3512c046.jpg";